export default __webpack_public_path__ + "static/media/percent_time_relationship.2168efe5.csv";